import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthGuard, FremiumGuard } from './guards';
import { LogoutComponent } from './pages/logout';
import { RedirectSSOComponent } from './pages/redirect-sso';
import { SimulatorPageComponent } from './pages/simulator';
import { cuponsComponent } from './pages/cupons';
import { AboutComponent } from './pages/about';
import { ListingPageComponent } from './pages/listing/listing-page.component';
import { NoContentComponent } from './pages/no-content';
import { StatusComponent } from './pages/status/status.component';
import {EmptyPage} from './pages/empty/empty.page';
import { environment } from '../environments/environment';

function buildPortalRedirectUrl(route: ActivatedRouteSnapshot): string {
  const data = (route.data || {}) as { portalPath?: string; useIdQuery?: boolean };
  let portalPath = data.portalPath || '/dashboard/parcerias-exclusivas';

  if (data.useIdQuery) {
    const id = route.paramMap.get('id');
    if (id) {
      portalPath = `${portalPath}?id=${encodeURIComponent(id)}`;
    }
  }

  return `${environment.PORTAL_URL}${portalPath}`;
}

const portalParceriasChildren: Routes = [
  {
    path: '',
    component: EmptyPage,
    resolve: { url: 'portalUrlRedirectResolver' },
    data: { portalPath: '/dashboard/parcerias-exclusivas' },
  },
  {
    path: 'cadastrar',
    component: EmptyPage,
    resolve: { url: 'portalUrlRedirectResolver' },
    data: { portalPath: '/dashboard/parcerias-exclusivas/cadastrar' },
  },
  {
    path: ':id',
    component: EmptyPage,
    resolve: { url: 'portalUrlRedirectResolver' },
    data: { portalPath: '/dashboard/parcerias-exclusivas/cadastrar', useIdQuery: true },
  },
];

const routes: Routes = [
  { path: '', component: EmptyPage },
  { path: 'fremium', component: EmptyPage },
  { path: 'home', canActivate: [AuthGuard, FremiumGuard], component: EmptyPage },
  { path: 'pagina-inicial', canActivate: [AuthGuard, FremiumGuard], component: EmptyPage },
  { path: 'assinaturas', component: EmptyPage },

  { path: 'redirect-sso', canActivate: [AuthGuard, FremiumGuard], component: RedirectSSOComponent },
  { path: 'login', canActivate: [AuthGuard], component: ListingPageComponent },

  { path: 'simulador', canActivate: [AuthGuard, FremiumGuard], component: SimulatorPageComponent },
  { path: 'simulator', canActivate: [AuthGuard, FremiumGuard], component: SimulatorPageComponent },

  { path: 'cupons', canActivate: [AuthGuard, FremiumGuard], component: cuponsComponent },

  { path: 'about', canActivate: [AuthGuard, FremiumGuard], component: AboutComponent },
  { path: 'sobre', canActivate: [AuthGuard, FremiumGuard], component: AboutComponent },

  { path: 'listing', canActivate: [AuthGuard, FremiumGuard], component: ListingPageComponent },
  { path: 'listagem', canActivate: [AuthGuard, FremiumGuard], component: ListingPageComponent },

  {
    path: 'parcerias-exclusivas',
    canActivate: [AuthGuard, FremiumGuard],
    children: portalParceriasChildren,
  },
  {
    path: 'parcerias-proprias',
    canActivate: [AuthGuard, FremiumGuard],
    children: portalParceriasChildren,
  },
  {
    path: 'sorteios',
    canActivate: [AuthGuard, FremiumGuard],
    component: EmptyPage,
    resolve: { url: 'portalUrlRedirectResolver' },
    data: { portalPath: '/sorteios' },
  },
  {
    path: 'sorteio',
    canActivate: [AuthGuard, FremiumGuard],
    component: EmptyPage,
    resolve: { url: 'portalUrlRedirectResolver' },
    data: { portalPath: '/sorteios' },
  },

  { path: 'status', component: StatusComponent },

  { path: 'logout', component: LogoutComponent },
  { path: 'sair', component: LogoutComponent },
  { path: '**', component: NoContentComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: 'externalUrlRedirectResolver',
      useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        window.location.href = (route.data as any).externalUrl;
      }
    },
    {
      provide: 'portalUrlRedirectResolver',
      useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        window.location.href = buildPortalRedirectUrl(route);
      }
    }
  ]
})
export class AppRoutingModule { }
